import { Skeleton } from '@/components/ui/skeleton';

export const DataSourcesSkeleton = () => {
  return (
    <div className='w-full'>
      <div className='animate-pulse space-y-6'>
        {/* Header with title and new collection button */}
        <div className='flex justify-between items-center mb-6'>
          <Skeleton className='h-8 w-48' />
          <Skeleton className='h-10 w-32' />
        </div>

        {/* Search Input */}
        <div className='mb-4'>
          <div className='relative w-96'>
            <Skeleton className='h-10 w-full' />
          </div>
        </div>

        {/* Collections Table */}
        <div className='border rounded-lg overflow-hidden'>
          {/* Table Header */}
          <div className='grid grid-cols-[1fr_1fr_1fr_60px] gap-4 p-3 bg-muted/50 border-b'>
            <Skeleton className='h-4 w-16' /> {/* Name */}
            <Skeleton className='h-4 w-24' /> {/* Description */}
            <Skeleton className='h-4 w-20' /> {/* Destination */}
            <div className='w-16' /> {/* Actions */}
          </div>

          {/* Table Body */}
          <div className='divide-y'>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
              <div
                key={index}
                className='grid grid-cols-[1fr_1fr_1fr_60px] gap-4 p-3 items-center cursor-pointer hover:bg-muted/50'
              >
                {/* Name */}
                <div className='flex flex-col'>
                  <Skeleton className='h-4 w-32 mb-1' />
                </div>

                {/* Description */}
                <Skeleton className='h-4 w-48' />

                {/* Destination */}
                <div className='flex items-center gap-2'>
                  <Skeleton className='w-4 h-4' />
                  <Skeleton className='h-4 w-16' />
                </div>

                {/* Actions */}
                <div className='flex justify-end'>
                  <Skeleton className='h-8 w-8 rounded-md' />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Pagination skeleton */}
        <div className='mt-4 flex justify-center'>
          <div className='flex items-center gap-2'>
            <Skeleton className='h-9 w-9' />
            <Skeleton className='h-9 w-9' />
            <Skeleton className='h-9 w-9' />
            <Skeleton className='h-9 w-9' />
            <Skeleton className='h-9 w-9' />
          </div>
        </div>
      </div>
    </div>
  );
};
